import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from '../api';
import * as Actions from './actions';

const fetchObservable = (successAction, offset = 0) => Api.fetch(offset).map(response => successAction(response));

const fetch = action$ =>
    action$
        .ofType(Actions.fetch.type)
        .mergeMap(({payload}) =>
            fetchObservable(Actions.fetchSuccess.action, payload.offset).catch(e =>
                Observable.of(Actions.fetchFailed.action(e)),
            ),
        );

const fetchMore = action$ =>
    action$
        .ofType(Actions.fetchMore.type)
        .mergeMap(({payload}) =>
            fetchObservable(Actions.fetchMoreSuccess.action, payload.offset).catch(e =>
                Observable.of(Actions.fetchMoreFailed.action(e)),
            ),
        );

const markNotificationAsReadObservable = notificationId =>
    Api.markNotificationAsRead(notificationId).map(response => Actions.fetchSuccess.action(response));

const markNotificationAsRead = action$ =>
    action$.ofType(Actions.markNotificationAsRead.type).mergeMap(({payload}) =>
        markNotificationAsReadObservable(payload.notificationId)
            .map(() => Actions.markNotificationAsReadSuccess.action(payload))
            .catch(e => Observable.of(Actions.markNotificationAsReadFailed.action(e))),
    );

const markAllNotificationsAsSeen = action$ =>
    action$.ofType(Actions.markAllNotificationsAsSeen.type).mergeMap(() =>
        Api.markAllNotificationsAsSeen()
            .map(response => Actions.markAllNotificationsAsSeenSuccess.action(response))
            .catch(e => Observable.of(Actions.markAllNotificationsAsSeenFailed.action(e))),
    );

export default combineEpics(fetch, fetchMore, markNotificationAsRead, markAllNotificationsAsSeen);
